import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const MonthEndBonanzaFaq = () => {

    const navigate = useNavigate();

    return (
        <div style={{ padding: '20px', color: '#FFFFFF' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
                <button className='back-button' onClick={() => navigate('/home')}>
                    <FiChevronLeft className='back-button-icon' />
                </button>
                <div style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 700, marginLeft: '20px' }}>FAQ</div>
            </div>
            <div>
                <ul className='mt-4'>
                    <li>
                        <p className='FAQ-Question'>What is the 5% Bitcoin rewards campaign?</p>
                        <p className='paragraph'>Earn up to 5% Bitcoin rewards on every eligible Elite card spend. 1% rewards are withdrawable on the Bitcoin blockchain, 4% can be used for redemptions within the GoSats app.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>The reward structure of the 5% rewards will be as follows:</p>
                        <p className='paragraph'>1% rewards are withdrawable on the Bitcoin blockchain</p>
                        <p className='paragraph'>4% rewards can be used for redemptions within the GoSats app</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What are eligible card spends?</p>
                        <p className='paragraph'>Most regular purchases qualify. Excluded categories include Fastag Recharge, Indian Railways, Bill/Utility Payments, Digital Wallet Loads, Real Estate, and more as listed in the T&C.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Are there any ineligible transaction categories for the 5% rewards on Elite Card Spends?</p>
                        <p className='paragraph'>Yes, transactions in Fastag Recharge, Indian Railways, Travel agencies, Tour Operators, Bill/Utility Payments, Digital Wallet Loads, Real Estate, Government services, Telecommunications, Gift, Novelty, and Souvenir Shops, Insurance, Quasi Cash, Fuel, Rent/Education, Toll, Bridge, Discount Stores and card spends on Voucher Purchases, SatsPay, BBPS and Gold Investments are excluded.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What if I don&apos;t receive my rewards?</p>
                        <p className='paragraph'>Please contact our in-app support or write to us at &quot;support@gosats.io&quot; from your registered email ID</p>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default MonthEndBonanzaFaq;
